import apiProvider from './provider';
import {
  REQUEST_LOGIN,
  GET_EMAIL_ADDRESS,
  FETCH_LOGO_AND_ID,
  FETCH_ORGANISATION_DETAILS,
} from './routes';
import { getClientDeviceLocation, getErrorMessage, getOrgPrettyName } from './utils';
import { API_BASE_URL } from 'src/globals';
import { ApiResponseWrapper, GET } from './apiHandler';
import { AxiosResponse } from 'axios';

export const fetchLogoAndId = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      API_BASE_URL + FETCH_LOGO_AND_ID,
      {
        headers: {
          'organisation-pretty-name': getOrgPrettyName(),
        },
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const loginRequest = async (value) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + REQUEST_LOGIN, value,
      {
        headers: {
          'organisation-pretty-name': getOrgPrettyName(),
          'user-location': getClientDeviceLocation()
        },
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const postEmailAddress = async (value) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + GET_EMAIL_ADDRESS, value,
      {
        headers: {
          'organisation-pretty-name': getOrgPrettyName(),
        },
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};


export const getOrganisationDetails = async (
  organisationPrettyName: string
): Promise<any> => {
  const headers = {
    'organisation-pretty-name': organisationPrettyName,
  };
  return GET(`${API_BASE_URL}${FETCH_ORGANISATION_DETAILS}`, undefined, undefined, headers);
};